import './Card.styles.css';

import { Image } from 'primereact/image';
import { FC } from 'react';

import { CardProps } from './Card.types';

const Card: FC<CardProps> = ({ card, isTableCard, glow }) => {
  return card ? (
    card?.reversed ? (
      <div className="card reversed-card" />
    ) : (
      <Image
        imageStyle={glow && { boxShadow: '0px 0px 13px rgba(255, 0, 255, 1)' }}
        className={`card-image ${isTableCard ? 'table-card' : ''}`}
        src={`/assets/cards/${card?.suit}/${card?.cardNumber}.png`}
        height={isTableCard ? '100' : '60'}
        width={isTableCard ? '70' : '40'}
      />
    )
  ) : (
    <div className="empty-card"></div>
  );
};

export default Card;
